import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n.use(HttpApi)
.use(initReactI18next)
.use(LanguageDetector)
.init({
  fallbackLng: 'en',
});

export default i18n;
